module.exports = __webpack_public_path__ + "img/img15.32caee9e.png";